import React from 'react';
import { SHARE_BASE_URL } from '../constants';
import { useGlobalState } from '../state/globalStateContext';
import { clsx, getHeroFromAnswers, sendEvent } from '../utils/utils';
import Footer from './Footer';

import * as styles from './Layout.module.scss';
import ShareModalOverlay from './ShareModalOverlay';

interface LayoutProps {
  largeSpikes?: boolean;
  noMobileShare?: boolean;
  children: React.ReactNode;
}

const Layout = ({ largeSpikes, noMobileShare, children }: LayoutProps): React.ReactElement => {
  const { shareModalUrl, openShareCard, closeShareCard, currentScreen, answers, selectedGender } =
    useGlobalState();
  return (
    <div className={styles.container}>
      <div className={clsx(styles.spikesContainer, largeSpikes && styles.largeSpikes)}></div>
      <div className={styles.backgroundContainer}>
        <main className={styles.main}>{children}</main>
        <Footer
          noMobileShare={noMobileShare}
          className={styles.footer}
          onShareClick={() => {
            openShareCard('footer');
          }}
        ></Footer>
        {shareModalUrl && (
          <ShareModalOverlay shareUrl={shareModalUrl} onClose={closeShareCard}></ShareModalOverlay>
        )}
      </div>
    </div>
  );
};

export default Layout;
